import request from '../index.js'

// 公告管理API
export const announcementApi = {
  // 获取后台公告列表
  getAdminList(params) {
    return request({
      url: '/announcements/admin/list',
      method: 'get',
      params
    })
  },

  // 创建公告
  create(data) {
    return request({
      url: '/announcements/admin',
      method: 'post',
      data
    })
  },

  // 更新公告
  update(id, data) {
    return request({
      url: `/announcements/admin/${id}`,
      method: 'put',
      data
    })
  },

  // 删除公告
  delete(id) {
    return request({
      url: `/announcements/admin/${id}`,
      method: 'delete'
    })
  },

  // 获取公告详情
  getDetail(id) {
    return request({
      url: `/announcements/detail/${id}`,
      method: 'get'
    })
  },

  // 获取前台公告列表
  getList(params) {
    return request({
      url: '/announcements',
      method: 'get',
      params
    })
  },

  // 获取置顶公告
  getTop(limit = 5) {
    return request({
      url: '/announcements/top',
      method: 'get',
      params: { limit }
    })
  },

  // 获取新手指南
  getGuides() {
    return request({
      url: '/announcements/guides',
      method: 'get'
    })
  },

  // 获取首页轮播
  getBanners() {
    return request({
      url: '/announcements/banners',
      method: 'get'
    })
  }
}

export default announcementApi
